export default __webpack_public_path__ + "static/media/pigeon.655094c1.jpg";